var map = {
	"./机构照片/养老院/黄浦区南京街道敬老院1.jpeg": "35b8",
	"./机构照片/养老院/黄浦区南京街道敬老院2.jpeg": "b3a2",
	"./机构照片/养老院/黄浦区南京街道敬老院3.jpeg": "191e",
	"./机构照片/睦邻中心/睦邻中心1.jpg": "0a5d",
	"./机构照片/睦邻中心/睦邻中心2.jpg": "7c52",
	"./机构照片/睦邻中心/睦邻分中心1.jpg": "de90",
	"./机构照片/睦邻中心/睦邻分中心2.jpg": "61e4",
	"./机构照片/睦邻中心/睦邻分中心3.jpg": "38c4",
	"./机构照片/适老化体验中心/适老化1.jpg": "1da2",
	"./机构照片/适老化体验中心/适老化2.jpg": "7ed9",
	"./机构照片/适老化体验中心/适老化3.jpg": "d56b",
	"./机构照片/长者运动健康之家/运动健康之家1.jpg": "c7bf",
	"./机构照片/长者运动健康之家/运动健康之家2.jpg": "9ee5",
	"./机构照片/长者运动健康之家/运动健康之家3.jpg": "1340"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "01a7";